import { useSelector } from "react-redux";

const useCheckPrivilages = (privilageId) => {
  const { privilagesData } = useSelector((state) => state.privilages);

  console.log(privilagesData)

  return privilagesData?.includes(privilageId);
};

export default useCheckPrivilages;


